import AntdDatePicker from 'antd/es/date-picker';
import DatePicker from './DatePicker';
import RangePicker from './RangePicker';
import DatePickerLess from './DatePickerLess';
import type { Props } from './types';

type MergeProps = {
    Less: typeof DatePickerLess;
};

const instence: typeof DatePicker & Props & MergeProps = Object.assign({}, AntdDatePicker, DatePicker, { RangePicker, Less: DatePickerLess });

export default instence;
